import {
  addAssetCollaborator,
  addCollaborator,
  addToCollection,
  clearReaction,
  create,
  createCollection,
  createUpload,
  discardDraft,
  forkCollection,
  get,
  getCollection,
  list,
  listAssetCollaborators,
  listCollaborators,
  listCollectionAssets,
  listCollections,
  listCopies,
  listPresets,
  listSimilar,
  listTags,
  listVersions,
  publish,
  remove,
  removeAssetCollaborator,
  removeCollaborator,
  removeCollection,
  removeFromCollection,
  search,
  searchCollections,
  setArchived,
  setMedia,
  setReaction,
  setSignals,
  startDraft,
  update,
  updateCollection,
  updateMedia,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AddAssetMediaRequest,
  ASSET_ANIMATION_MAX_SIDE,
  ASSET_COLLECTION_DESCRIPTION_MAX_CHARACTERS,
  ASSET_COLLECTION_MAX_ASSETS,
  ASSET_COLLECTION_MAX_COLLABORATORS,
  ASSET_COLLECTION_SEARCH_MAX_RESULTS,
  ASSET_COLLECTION_TITLE_MAX_CHARACTERS,
  ASSET_COPIES_MAX,
  ASSET_DESCRIPTION_MAX_CHARACTERS,
  ASSET_DESCRIPTION_MIN_CHARACTERS,
  ASSET_ICON_SIDE,
  ASSET_KINDS,
  ASSET_LABEL_MAX_CHARACTERS,
  ASSET_LANGUAGES,
  ASSET_MAX_COLLABORATORS,
  ASSET_PICTURE_MAX_SIDE,
  ASSET_PICTURE_MIN_SIDE,
  ASSET_PICTURE_SCALES,
  ASSET_PRESETS_MAX,
  ASSET_SEARCH_MAX_COLLECTIONS,
  ASSET_SEARCH_MAX_RESULTS,
  ASSET_SIMILAR_MAX_PER_LIST,
  ASSET_SLUG_MAX_CHARACTERS,
  ASSET_STILL_MAX_SIDE,
  ASSET_TAG_MAX_CHARACTERS,
  ASSET_TAG_MAX_COUNT,
  ASSET_TITLE_MAX_CHARACTERS,
  ASSET_UPLOAD_CONTENT_TYPES,
  ASSET_UPLOAD_MAX_BYTES,
  ASSET_VIDEO_MAX_SIDES,
  Asset,
  AssetCollaborator,
  AssetCollaboratorParams,
  AssetCollaboratorsResponse,
  AssetCollection,
  AssetCollectionAssetParams,
  AssetCollectionCollaborator,
  AssetCollectionCollaboratorParams,
  AssetCollectionCollaboratorsResponse,
  AssetCollectionId,
  AssetCollectionIdParams,
  AssetCollectionPage,
  AssetCollectionPicture,
  AssetCollectionResponse,
  AssetCollectionRole,
  AssetCollectionVisibility,
  AssetCopies,
  AssetCopy,
  AssetCopyMatch,
  AssetDraftParams,
  AssetFraming,
  AssetId,
  AssetIdParams,
  AssetKind,
  AssetLanguage,
  AssetListStatus,
  AssetMedia,
  AssetMediaRejection,
  AssetPage,
  AssetPresets,
  AssetProcessingOptions,
  AssetPublishProblems,
  AssetPublishRequirement,
  AssetReaction,
  AssetResponse,
  AssetSearchPage,
  AssetSearchResult,
  AssetSort,
  AssetStats,
  AssetTag,
  AssetTagCount,
  AssetUpload,
  type AssetUploadContentType,
  AssetUploadId,
  AssetUsageRequest,
  AssetVersionId,
  AssetVersionParams,
  AssetVersionProblem,
  AssetVersionStatus,
  AssetVersionsResponse,
  AudioAssetMedia,
  AudioProcessingOptions,
  CreateAssetCollectionRequest,
  CreateAssetRequest,
  CreateAssetUploadRequest,
  CreateAssetUploadResponse,
  ForkAssetCollectionRequest,
  GetAssetQuery,
  ImageAssetMedia,
  ImageProcessingOptions,
  ListAssetCollectionsQuery,
  ListAssetsQuery,
  ListAssetTagsQuery,
  ListAssetTagsResponse,
  ListCollectionAssetsQuery,
  ListSimilarAssetsQuery,
  PublishAssetRequest,
  SearchAssetCollectionsQuery,
  SearchAssetsQuery,
  SetAssetArchivedRequest,
  SetAssetReactionRequest,
  SetAssetSignalsRequest,
  SimilarAsset,
  SimilarAssets,
  StartAssetDraftRequest,
  UpdateAssetCollectionRequest,
  UpdateAssetMediaRequest,
  UpdateAssetRequest,
  VideoAssetMedia,
  VideoProcessingOptions,
  VideoSource,
} from "./schemas";

export const contract = {
  list,
  create,
  search,
  get,
  delete: remove,
  archive: { set: setArchived },
  versions: { list: listVersions, signals: { update: setSignals } },
  drafts: {
    create: startDraft,
    update,
    delete: discardDraft,
    publish,
    uploads: { create: createUpload },
    media: { set: setMedia, update: updateMedia },
    copies: { list: listCopies },
  },
  collaborators: {
    list: listAssetCollaborators,
    set: addAssetCollaborator,
    delete: removeAssetCollaborator,
  },
  reaction: { set: setReaction, delete: clearReaction },
  similar: { list: listSimilar },
  presets: { list: listPresets },
  tags: { list: listTags },
  collections: {
    list: listCollections,
    create: createCollection,
    search: searchCollections,
    get: getCollection,
    update: updateCollection,
    delete: removeCollection,
    fork: forkCollection,
    assets: { list: listCollectionAssets, set: addToCollection, delete: removeFromCollection },
    collaborators: { list: listCollaborators, set: addCollaborator, delete: removeCollaborator },
  },
} as const;
